var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiQuerySpaceGroupPermissions, ApiUpdateSpaceGroupPermissions } from '@/infrastructure/api-functions/api-space-group-permission.interface';
let GroupPermissionRepositoryImpl = class GroupPermissionRepositoryImpl {
    constructor(_apiQuerySpaceGroupPermissions, _apiUpdateSpaceGroupPermissions) {
        this._apiQuerySpaceGroupPermissions = _apiQuerySpaceGroupPermissions;
        this._apiUpdateSpaceGroupPermissions = _apiUpdateSpaceGroupPermissions;
    }
    async updateSpaceGroupPermissions(spaceId, permissions) {
        const request = {
            spaceId,
            dept_permission_list: permissions.map(item => ({
                department_id: item.groupId,
                permission_type: item.permission,
            })),
        };
        await this._apiUpdateSpaceGroupPermissions.updateSpaceGroupPermissions(request);
    }
    async querySpaceGroupPermissions(spaceId) {
        const resp = await this._apiQuerySpaceGroupPermissions.querySpaceGroupPermissions({ spaceId });
        const result = resp.department_permission_list.map(this._convert);
        return result;
    }
    _convert(item) {
        return {
            groupId: item.department_id,
            permission: item.permission_type,
            label: item.department_name,
            avatarColor: item.avatar_color,
            avatarPattern: item.avatar_pattern,
            avatarValue: item.avatar_value,
        };
    }
};
GroupPermissionRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiQuerySpaceGroupPermissions)),
    __param(1, inject(ApiUpdateSpaceGroupPermissions)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiQuerySpaceGroupPermissions !== "undefined" && ApiQuerySpaceGroupPermissions) === "function" ? _a : Object, typeof (_b = typeof ApiUpdateSpaceGroupPermissions !== "undefined" && ApiUpdateSpaceGroupPermissions) === "function" ? _b : Object])
], GroupPermissionRepositoryImpl);
export { GroupPermissionRepositoryImpl };
